// Etsy kargo firmalari. Etsy carrier_name'i kendi listesindeki ADLA eslestirir
// (bilinmeyen ad "other" olur, alici takip baglantisi goremez). Eskiden
// "usps"/"royal-mail" gibi kodlar gidiyordu ve POD siparislerinin asil
// tasiyicisi (Amazon Logistics US) listede yoktu.

export const CARRIERS = [
  "USPS",
  "UPS",
  "FedEx",
  "Amazon Logistics US",
  "DHL eCommerce",
  "DHL Express",
  "OnTrac",
  "LaserShip",
  "Asendia USA",
  "UniUni",
  "Canada Post",
  "Royal Mail",
  "Australia Post",
  "PTT",
] as const;

/** Takip numarasinin bicimine gore tasiyici tahmini (bilinmiyorsa null). */
export function guessCarrier(code: string): string | null {
  const c = code.replace(/\s+/g, "").toUpperCase();
  if (!c) return null;
  if (/^1Z[0-9A-Z]{16}$/.test(c)) return "UPS";
  if (/^TBA\d{9,}$/.test(c)) return "Amazon Logistics US";
  if (/^(94|93|92|95)\d{18,24}$/.test(c) || /^(420\d{5,9})?9\d{21,25}$/.test(c)) return "USPS";
  if (/^[A-Z]{2}\d{9}US$/.test(c)) return "USPS";
  if (/^GM\d{16,}$/.test(c) || /^(LX|RX)\d{9}DE$/.test(c)) return "DHL eCommerce";
  if (/^\d{10}$/.test(c)) return "DHL Express";
  if (/^(\d{12}|\d{15}|\d{20}|\d{22})$/.test(c)) return "FedEx";
  if (/^C\d{14}$/.test(c)) return "OnTrac";
  if (/^1LS\d{12,}$/.test(c) || /^L[A-Z]\d{8}$/.test(c)) return "LaserShip";
  if (/^[A-Z]{2}\d{9}GB$/.test(c)) return "Royal Mail";
  if (/^[A-Z]{2}\d{9}TR$/.test(c)) return "PTT";
  return null;
}

const LAST_KEY = "erc_last_carrier";

export function lastCarrier(): string {
  try { return localStorage.getItem(LAST_KEY) || ""; } catch { return ""; }
}

export function rememberCarrier(name: string) {
  try { if (name.trim()) localStorage.setItem(LAST_KEY, name.trim()); } catch { /* yoksay */ }
}

/** Gonderilmis kargonun takip baglantisi (bilinen tasiyicilar icin). */
export function trackingUrl(carrier: string, code: string): string | null {
  const c = (carrier || "").toLowerCase();
  if (c.includes("usps")) return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${code}`;
  if (c.includes("ups")) return `https://www.ups.com/track?tracknum=${code}`;
  if (c.includes("fedex")) return `https://www.fedex.com/fedextrack/?trknbr=${code}`;
  if (c.includes("amazon")) return `https://track.amazon.com/tracking/${code}`;
  if (c.includes("dhl")) return `https://www.dhl.com/global-en/home/tracking.html?tracking-id=${code}`;
  if (c.includes("ontrac")) return `https://www.ontrac.com/tracking/?number=${code}`;
  if (c.includes("royal")) return `https://www.royalmail.com/track-your-item#/tracking-results/${code}`;
  if (c.includes("ptt")) return `https://gonderitakip.ptt.gov.tr/Track/Verify?q=${code}`;
  return null;
}
